export const radioFields = [
    {
        id: "",
        label: "Select",
        value: "",
    },
    {
        id: "horizontal",
        label: "horizontal",
        value: "horizontal",
    },
    {
        id: "vertical",
        label: "vertical",
        value: "vertical",
    },
];
